import { render, staticRenderFns } from "./RoundSlider.vue?vue&type=template&id=61177ab0&scoped=true"
import script from "./RoundSlider.vue?vue&type=script&lang=js"
export * from "./RoundSlider.vue?vue&type=script&lang=js"
import style0 from "./RoundSlider.vue?vue&type=style&index=0&id=61177ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61177ab0",
  null
  
)

export default component.exports